/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React, { useState, useEffect } from 'react';
import { Input } from 'reactstrap';
import AddPersona from './AddPersona.js'
import ModifyPersona from './ModifyPersona.js'
import { unEscapeHTML } from '../Utils/text_functions.js'
import { FiEdit, FiTrash2 } from 'react-icons/fi';
import { useMediaQuery, Dialog, DialogTitle, Alert, Button, Box, IconButton, Paper, Tab, Tabs, useTheme } from '@mui/material';
import { IoClose } from "react-icons/io5";
import { NoResults } from '../Components/NoResults.js';
import { ScrollableDialogContent } from '../Components/ScrollableDialogContent.js';


const PersonaList = ({ personas, loadPersonas, handlePersonaClick, triggerPersonaList, setTriggerPersonaList, default_data, getToken, getUser }) => {

  const [activeTab, setActiveTab] = useState('public');
  const [user_id, setUserId] = useState(null);
  const [paid, setPaid] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [searchText, setSearchText] = useState('');

  const [selectedPersona, setSelectedPersona] = useState(null);

  const [triggerAddPersona, setTriggerAddPersona] = useState(0);
  const [triggerModifyPersona, setTriggerModifyPersona] = useState(0);
  var loaded_static = false;
  const theme = useTheme();

  const [modalIsOpen, setIsOpen] = React.useState(false);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  function addPersona() {
    setTriggerAddPersona(1)
  }

  function closeModal() {
    setTriggerPersonaList(0);
    setIsOpen(false);
  }

  function handleSearchChange(event) {
    setSearchText(event.target.value);
  }

  function deleteClick(e) {
    var key = e.target.dataset.key;
    if(key === undefined) {
      key = e.target.parentNode.dataset.key;
    }
    if(key === undefined) {
      return;
    }
    key = key.toString();

    e.target.disabled = true;

    e.stopPropagation();

    if(key == null || key == '') {
      return;
    }

    var token = getToken()
    if(token === false) {
      return;
    }

    var user = getUser()

    if(user === false || user == null) {
       window.location = '/login';
       return;
    }
  
    fetch(default_data.default_prompt_service_url + '/persona', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'x-access-tokens': `${token}`
      },        
      body: JSON.stringify({
        id: key
      })
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('An error occurred while getting data.');
      })
      .then(data => {
        if(data.status != 200) {
            return;
        }
        loadPersonas()
      })
      .catch(error => {
        console.log(error);
      });    
  }

  function editClick(key) {
    const selectedPersona = personas.find(persona => persona.id == key);

    if (selectedPersona) {
      setSelectedPersona(selectedPersona);
      setTriggerModifyPersona(1);
    }    
  }

  useEffect(() => {
    if (triggerPersonaList) {
      if (triggerPersonaList === 1) {
        setIsOpen(true)
      }
    }
  }, [triggerPersonaList]);

  useEffect(() => {

    if(loaded || loaded_static) {
      return;
    }

    setLoaded(true)
    loaded_static = true;

    var user = getUser()
    setUserId(user.id)
    if(user.paid !== undefined && (user.paid === 1 || user.paid === '1' || user.paid === true)) {
      setPaid(true)
    }
    else {
      setPaid(false)
    }    
  }, [])

    const filteredPrivateItems = personas.filter((item) => {
      return item.public === false && (item.name.toLowerCase().includes(searchText.toLowerCase()) || item.description.toLowerCase().includes(searchText.toLowerCase()));
    });

    const filteredAllItems = personas.filter((item) => {
      return (item.name.toLowerCase().includes(searchText.toLowerCase()) || item.description.toLowerCase().includes(searchText.toLowerCase()));
    });

    const filteredPublicItems = personas.filter((item) => {
        return item.public === true && (item.name.toLowerCase().includes(searchText.toLowerCase()) || item.description.toLowerCase().includes(searchText.toLowerCase()));
    });

    const DisplayDataPrivate = () => {

      return (filteredPrivateItems.map(
      (info)=>{ 
          return(
            <PersonaVignette key={info.id} user_id={user_id} info={info} personaClick={personaClick} />
          )
      }));      
    }

    const DisplayDataAll = () => {

      return (filteredAllItems.map(
      (info)=>{ 
          return(
            <PersonaVignette key={info.id} user_id={user_id} info={info} personaClick={personaClick} />
          )
      }));      
    }

    const DisplayDataPublic = () => {
      return (filteredPublicItems.map(
      (info)=>{ 
          return(
            <PersonaVignette key={info.id} user_id={user_id} info={info} personaClick={personaClick} />
          )
      }));      
    }      

    const PersonaVignette = ( {user_id, info, personaClick }) => {
      const [personaIcon, setPersonaIcon] = useState('');
    
      useEffect(() => {
        async function fetchPersonaIcon() {
          const icon = await getPersonaIcon(info);
          setPersonaIcon(icon);
        }
    
        fetchPersonaIcon();
      }, [info]);

      async function getPersonaIcon(info) {
        if (info.image !== undefined && info.image !== null && info.image !== '') {
          return <img tag={info.id}  style={{ width: '100px', marginRight: '20px' }}  src={`data:image/png;base64,${info.image}`} alt={info.name} />;
        }
      
        const filename = `logo-persona-${info.id}.png`;
        const fileExists = await checkFileExists(filename);
      
        if (fileExists) {
          return <img tag={info.id}  style={{ width: '100px', marginRight: '20px' }}  src={filename} alt={info.name} />;
        }
      
        return <img tag={info.id}  style={{ width: '100px', marginRight: '20px' }} src="logo-persona-unknown.png" alt={info.name} />;
      }
                
      function checkFileExists(filename) {
        const publicPath = process.env.PUBLIC_URL;
        const filePath = `${publicPath}/${filename}`;
    
        return new Promise((resolve, reject) => {
          const img = new Image();
    
          img.onload = function() {
            resolve(true); // File exists
          };
    
          img.onerror = function() {
            resolve(false); // File does not exist
          };
    
          img.src = filePath;
        });
      }
        
      return(
        <Paper
          key={info.id}
          tag={info.id}
          className="prompt-item"
          onClick={personaClick}
          variant='outlined'
          sx={{
            padding: 2,
            width: '100%',
            backgroundColor: theme.palette.card.backgroundColor,
            marginBottom: '1rem',
            border: theme.palette.card.border,
            cursor: 'pointer',
            '&:hover': theme.palette.card.hover,
          }}
        >
          <div tag={info.id} className="prompt-item-public">
            {
              info.public === true ?
                <span>Public</span>
              :
                <span>Private</span>
            }            
          </div>
          <div tag={info.id} className="prompt-item-persona">
            {
              info.user_id !== undefined && info.user_id !== -1 && info.user_id == user_id ? 
              <span>
                <span className="sidecar-button-nobg" data-key={info.id} onClick={()=>{editClick(info.id)}}>
                  <FiEdit data-key={info.id} size={18} />
                </span>
                <span className="sidecar-button-nobg" data-key={info.id} onClick={deleteClick}>
                  <FiTrash2 data-key={info.id} size={18} />
                </span>
              </span>
              :
              ''
            }
          </div>
          <div tag={info.id} className="prompt-item-title">
            {personaIcon ? (
              personaIcon
            ) : (
              <img style={{width:'100px', marginRight: '20px'}} src="logo-persona-unknown.png" alt={info.name} tag={info.id} />
            )}
            
            {unEscapeHTML(info.name)}
          </div>
          <div tag={info.id} className="prompt-item-description">
            {unEscapeHTML(info.description)}
          </div>
        </Paper>              
      )
    }      

  function personaClick(e) {    
    var tag = e.target.getAttribute('tag');
    if(tag == null) {
      return;
    }
    tag = tag.toString();
    var persona = -1;
    personas.forEach((element) => {
      if(element['id'] == tag) {
        persona = element['id']
      }
    });    

    if(persona != -1) {      
      handlePersonaClick(persona)
      closeModal()
    }
  }

  const fullScreen = useMediaQuery(theme.breakpoints.down('mobile'));

  return (
    <>
      <Dialog fullWidth={true} maxWidth="lg" fullScreen={fullScreen} open={modalIsOpen} onClose={closeModal} aria-labelledby="form-dialog-title">
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              Personas
            <IconButton onClick={closeModal}>
              <IoClose />
            </IconButton>
          </Box>
        </DialogTitle>
        <ScrollableDialogContent sx={{height: '80vh'}} modalIsOpen={modalIsOpen}>
          <Alert severity="info" sx={{mb: 3}}>  
            NOTE: think of a Persona like talking to people with different skillsets, it customizes the chatbot's behavior and personality. By changing the persona, the chatbot can adopt different tones, skillsets, and response formats to better suit your needs and preferences of different scenarios.
          </Alert>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            { paid ? 
              <Button variant={'outlined'} onClick={addPersona}>Create a new Persona (advanced mode)</Button>
            :
              <Button variant={'outlined'} onClick={addPersona} disabled={true}>Create a new Persona (advanced mode) (paid only)</Button>
            }
          </Box>  
          <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)}>
            <Tab label="All" value={'all'} />
            <Tab label="Public" value={'public'} />
            <Tab label="Private" value={'private'} />
          </Tabs>
          <div className="prompt-persona">
            <Input
              type="text"
              placeholder="Search personas"
              value={searchText}
              onChange={handleSearchChange}
              style={{ marginBottom: '1rem' }}
            />
          </div>
          
          <div className="modal_header_sec">
            {
              (activeTab === 'public') ?
              <span>Public Personas</span>
              : activeTab === 'all' ?
              <span>All Personas</span> :
              <span>Private Personas</span>
            }        
          </div>

          <div className="prompt-container">              
            { 
              activeTab === 'public' ? 
              (personas.length === 0) ?
                <div className="loading">Loading...</div> : 
                (filteredPublicItems.length === 0) ?
                  <NoResults message="No public personas found" />:
                  <DisplayDataPublic />
              :
              activeTab === 'all' ? 
              (personas.length === 0) ?
                <div className="loading">Loading...</div> : 
                (filteredAllItems.length === 0) ?
                  <NoResults message="No personas found" />:
                  <DisplayDataAll />
              :
              (personas.length === 0) ? 
                <div className="loading">Loading...</div> : 
                (filteredPrivateItems.length === 0) ?
                  <NoResults message="No private personas found" />:
                  <DisplayDataPrivate />
            }
            
          </div>
        </ScrollableDialogContent>
      </Dialog>
      <AddPersona loadPersonas={loadPersonas} setTriggerAddPersona={setTriggerAddPersona} triggerAddPersona={triggerAddPersona} personas={personas} default_data={default_data} getToken={getToken} />
      <ModifyPersona selectedPersona={selectedPersona} loadPersonas={loadPersonas} setTriggerModifyPersona={setTriggerModifyPersona} triggerModifyPersona={triggerModifyPersona} default_data={default_data} getToken={getToken} getUser={getUser}  />
    </>
  );
}
export default PersonaList;
